import lazyLoadView from "@/router/lazyLoadView";

export default [
  {
    path: "/admin",
    component: () => lazyLoadView(import("@/sections/admin/pages/Index")),
    meta: {
      adminRequired: true,
      routerKeySection: "admin"
    },
    children: [
      {
        name: "AdminDashboard",
        path: "",
        redirect: { name: "AdminDistroHome" },
        component: () =>
          lazyLoadView(import("@/sections/admin/pages/Dashboard"))
      },
      {
        path: "distro",
        component: () =>
          lazyLoadView(import("@/sections/admin/pages/distro/Index")),
        children: [
          {
            name: "AdminDistroHome",
            path: "",
            component: () =>
              lazyLoadView(import("@/sections/admin/pages/distro/Home"))
          },
          {
            name: "AdminDistroReleaseReview",
            path: ":user_id/review",
            component: () =>
              lazyLoadView(
                import("@/sections/admin/pages/distro/ReleaseReview")
              ),
            meta: {
              review: true
            }
          },
          {
            name: "AdminDistroReleaseView",
            path: ":user_id/view",
            component: () =>
              lazyLoadView(
                import("@/sections/admin/pages/distro/ReleaseReview")
              )
          }
        ]
      },
      {
        path: "faqs",
        component: () =>
          lazyLoadView(import("@/sections/admin/pages/faqs/Home"))
      },
      {
        path: "users",
        component: () =>
          lazyLoadView(import("@/sections/admin/pages/users/Index")),
        children: [
          {
            name: "AdminUserHome",
            path: "",
            component: () =>
              lazyLoadView(import("@/sections/admin/pages/users/Home"))
          },

          {
            name: "AdminUserInfoView",
            path: ":user_id/view",
            component: () =>
              lazyLoadView(import("@/sections/admin/pages/users/UserReview"))
          }
        ]
      }
    ]
  }
];
